export default {
  showRegistrationModalOnQr: false,
  general: {
    showFavourites: false,
    showSoldNeighbourhoods: false,
    appResetTimeoutMinutes: 15,
  },
  filter: {
    enabled: false,
  },
};
